import { Group, Radio, Stack } from "@mantine/core";
import { FormField } from "../../../../../BuildingBlocks/Forms/MantineFormFields/FormField";
import {
  InstallmentCalculationBase,
  type InstallmentConfiguration
} from "../../../../DeliveryOverview.types";

interface InitialInstallmentFieldsProps {
  onChange: (installment: InstallmentConfiguration) => void;
  installment: InstallmentConfiguration;
}

function InitialInstallmentFields({
  onChange,
  installment
}: InitialInstallmentFieldsProps) {
  function getFormFields() {
    if (
      installment.calculation_base ===
      InstallmentCalculationBase.EstimatedDeliveryAmount
    ) {
      return (
        <Group grow justify="space-between">
          <FormField
            decimalScale={3}
            key="installment-delivery-amount-in-kwh"
            label="Verbrauch im Jahr"
            min={0}
            placeholder="Verbrauch eingeben"
            rightSection="kWh"
            rightSectionWidth={40}
            type="number"
            value={installment.estimated_delivery_amount_in_kwh ?? undefined}
            onChange={(value) => {
              onChange({
                ...installment,
                estimated_delivery_amount_in_kwh: value
                  ? value.toString()
                  : null
              });
            }}
          />
          <FormField
            decimalScale={2}
            key="installment-estimated-share-direct-delivery-in-percent"
            label="Anteil Direktlieferung"
            max={100}
            min={0}
            placeholder="Anteil eingeben"
            rightSection="%"
            type="number"
            value={
              installment.estimated_share_direct_delivery_in_percent ??
              undefined
            }
            onChange={(value) => {
              onChange({
                ...installment,
                estimated_share_direct_delivery_in_percent: value
                  ? value.toString()
                  : null
              });
            }}
          />
        </Group>
      );
    } else if (
      installment.calculation_base ===
      InstallmentCalculationBase.EstimatedInstallmentPayment
    ) {
      return (
        <FormField
          decimalScale={2}
          key="installment-payments-made"
          label="Monatlicher Abschlag (Brutto)"
          min={0}
          placeholder="Abschlag eingeben"
          rightSection="€"
          type="number"
          value={installment.estimated_installment_in_euro ?? undefined}
          onChange={(value) => {
            onChange({
              ...installment,
              estimated_installment_in_euro: value ? value.toString() : null
            });
          }}
        />
      );
    }
  }
  return (
    <Stack className="InitialInstallmentFields" my="md">
      <Radio.Group
        label="Die Abschläge für das erste Jahr basieren auf"
        value={installment.calculation_base}
        onChange={(value) =>
          onChange({
            ...installment,
            calculation_base: value as InstallmentCalculationBase
          })
        }
      >
        <Group>
          <Radio
            key={InstallmentCalculationBase.EstimatedInstallmentPayment}
            label="Geschätztem Abschlag"
            value={InstallmentCalculationBase.EstimatedInstallmentPayment}
          />
          <Radio
            key={InstallmentCalculationBase.EstimatedDeliveryAmount}
            label="Geschätztem Verbrauch"
            value={InstallmentCalculationBase.EstimatedDeliveryAmount}
          />
        </Group>
      </Radio.Group>
      {getFormFields()}
    </Stack>
  );
}

export { InitialInstallmentFields };
